import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wp-home-page-resolver',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageResolverComponent {}
